export default "__VITE_ASSET__BBmZUIUD__"